export default {
  sidebar: {
    dashboard: 'Armaturenbrett',
    chat: 'Chat',
    preview: 'Vorschau',
    trainingData: 'Trainingsdaten',
    chatInterface: 'Chat-Interface',
    dataSources: 'Datenquellen',
    dataSourcesWebsite: 'Website',
    dataSourcesFiles: 'Dateien',
    dataSourcesText: 'Text',
    dataSourcesFaq: 'FAQ',
    dataSourcesExternal: 'Extern',
    connections: 'Verbindungen',
    connectionsWebsite: 'Website',
    connectionsWhatsapp: 'WhatsApp',
    data: 'Daten',
    products: 'Produkte',
    content: 'Inhalt',
    inbox: 'Posteingang',
    tickets: 'Tickets',
    leads: 'Führt',
    analytics: 'Analytik',
    chats: 'Chats',
    topics: 'Themen',
    chatLogs: 'Chat-Protokolle',
    emailSettings: 'E-Mail-Einstellungen',
    profile: 'Profil',
  },
  topbar: {
    accountSettings: 'Kontoeinstellungen',
  },
  account: {
    profile: 'Profil',
    fullName: 'Vor- und Nachname',
    securityAndAccess: 'Sicherheit und Zugriff',
    workspace: 'Arbeitsbereich',
    billing: 'Abrechnung',
    userInformation: 'Benutzerinformationen',
    email: 'E-Mail',
    firstName: 'Vorname',
    lastName: 'Nachname',
    updateProfile: 'Profil aktualisieren',
    profileImage: 'Profilbild',
    uploadImage: 'Bild hochladen',
    remove: 'Entfernen',
    uploadSupport: 'Unterstützt JPG-, PNG- und SVG-Dateien bis zu 1 MB',
    dataPrivacy: 'Datenschutz',
    cookies: 'Cookies',
    withdrawCookieConsent: 'Cookie-Einwilligung widerrufen',
    dangerZone: 'Gefahrenzone',
    deleteAccount: 'Konto löschen',
    deleteYourAccount: 'Dein Konto löschen',
    password: 'Passwort',
    passwordDescription: 'Ändern Sie Ihr Passwort, um Ihr Konto zu schützen',
    setNewPassword: 'Neues Passwort festlegen',
    twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
    twoFactorDescription: 'Fügen Sie Ihrem Konto eine zusätzliche Sicherheitsebene hinzu',
    enable: 'Aktivieren',
    disable: 'Deaktivieren',
    workspaceManageMembers: 'Verwalte deine Teammitglieder und lade neue ein',
    admin: 'Admin',
    member: 'Mitglied',
    owner: 'Eigentümer',
    viewer: 'Betrachter',
    guest: 'Gast',
    user: 'Benutzer',

    // Security Status
    securityStatus: 'Sicherheitsstatus',
    securityStrong: 'Stark',
    securityMedium: 'Mittel',
    securityWeak: 'Schwach',
    securityLoading: 'Lädt...',

    // Two Factor Status
    twoFactorEnabled: 'Aktiviert',
    twoFactorDisabled: 'Deaktiviert',
    lastPasswordChange: 'Zuletzt geändert',

    // Password Modal
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    changePassword: 'Passwort ändern',

    // Two Factor Modal
    enableTwoFactorTitle: 'Zwei-Faktor-Authentifizierung aktivieren',
    disableTwoFactorTitle: 'Zwei-Faktor-Authentifizierung deaktivieren',
    enableTwoFactorMessage: 'Sie werden weitergeleitet, um die Zwei-Faktor-Authentifizierung mit einer Authentifizierungs-App einzurichten. Möchten Sie fortfahren?',
    disableTwoFactorMessage: 'Sind Sie sicher, dass Sie die Zwei-Faktor-Authentifizierung deaktivieren möchten? Dies verringert die Sicherheit Ihres Kontos.',
    continue: 'Fortfahren',
    workspaceIdentification: 'Arbeitsbereich-Identifikation',
    workspaceName: 'Name des Arbeitsbereichs',
    workspacePlaceholder: 'Arbeitsbereich',
    yourTeam: 'Dein Team',
    manageTeamMembers: 'Verwalte deine Teammitglieder und lade neue ein',
    invite: 'Einladen',
    editor: 'Bearbeiter',
    deleteWorkspace: 'Arbeitsbereich löschen',
    deleteWorkspaceWarning: 'Sobald du deinen Arbeitsbereich löschst, gibt es kein Zurück mehr. Bitte sei dir sicher.',
    deleteYourWorkspace: 'Deinen Arbeitsbereich löschen',
    confirmDelete: 'Löschen bestätigen',
    deleteConfirmationText: 'Sind Sie sicher, dass Sie dieses Element löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',

    // Team Management
    joinDate: 'Beitrittsdatum',
    noTeamMembers: 'Keine Teammitglieder',
    inviteTeamMember: 'Teammitglied einladen',
    enterTeamEmail: 'E-Mail eingeben',
    role: 'Rolle',
    sendInvite: 'Einladung senden',

    // Billing Information
    billingInformation: 'Rechnungsinformationen',
    billingDescription: 'Wird auf jeder Rechnung angezeigt. Änderungen gelten nicht für bereits ausgestellte Rechnungen.',
    billingName: 'Rechnungsname',
    enterBillingName: 'Rechnungsname eingeben',
    billingEmail: 'Rechnungs-E-Mail',
    enterBillingEmail: 'Rechnungs-E-Mail eingeben',
    billingVatId: 'USt-IdNr.',
    enterVatId: 'USt-IdNr. eingeben',
    yourStreet: 'Ihre Straße',
    enterStreet: 'Straße eingeben',
    yourZipCode: 'Ihre Postleitzahl',
    enterZipCode: 'Postleitzahl eingeben',
    yourCity: 'Ihre Stadt',
    enterCity: 'Stadt eingeben',
    yourCountry: 'Ihr Land',
    selectCountry: 'Land auswählen',
    cancelChange: 'Änderung abbrechen',
    saveChanges: 'Änderungen speichern',
    vatId: 'USt-IdNr.',
    address: 'Adresse',
    street: 'Straße',
    zipCode: 'Postleitzahl',
    city: 'Stadt',

    // Payment Methods
    paymentMethod: 'Zahlungsmethode',
    changePaymentMethod: 'Zahlungsmethode ändern',
    creditCard: 'Kreditkarte',
    bankTransfer: 'Banküberweisung',
    cardNumber: 'Kartennummer',
    enterCardNumber: 'Kartennummer eingeben',
    expiryDate: 'Ablaufdatum',
    cvv: 'CVV',
    enterCvv: 'CVV eingeben',
    cardholderName: 'Karteninhaber',
    enterCardholderName: 'Karteninhaber eingeben',
    paypalAccount: 'PayPal Konto',
    paypalDescription: 'Sie werden zu PayPal weitergeleitet, um die Zahlung abzuschließen',
    bankTransferInfo: 'Bankverbindung',
    bankName: 'Bankname',
    accountNumber: 'Kontonummer',
    routingNumber: 'Bankleitzahl',
    swiftCode: 'SWIFT-Code',
    savePaymentMethod: 'Zahlungsmethode speichern',

    // Invoices
    invoices: 'Rechnungen',
    invoicesDescription: 'Alle Rechnungen für Ihren Plan.',
    noInvoices: 'Keine Rechnungen gefunden.',
    invoiceId: 'Rechnungs-ID',
    invoiceDate: 'Rechnungsdatum',
    plan: 'Plan',
    amount: 'Betrag',
    status: 'Status',
    download: 'Herunterladen',
    downloadInvoice: 'Rechnung herunterladen',
    invoiceStatusPaid: 'Bezahlt',
    invoiceStatusPending: 'Ausstehend',
    invoiceStatusFailed: 'Fehlgeschlagen',
    invoiceStatusCancelled: 'Storniert',
    invoiceStatusUnknown: 'Unbekannt',

    forgotPassword: 'Passwort vergessen',
    resetPassword: 'Passwort zurücksetzen',
    sendResetLink: 'Passwort-Reset-Link senden',
    resetLinkSent: 'Passwort-Reset-Link wurde an Ihre E-Mail gesendet',
    checkYourEmail: 'Bitte überprüfen Sie Ihre E-Mail und folgen Sie den Anweisungen',
    invalidResetLink: 'Ungültiger oder abgelaufener Reset-Link',
    passwordResetSuccess: 'Ihr Passwort wurde erfolgreich aktualisiert',
    enterNewPassword: 'Geben Sie Ihr neues Passwort ein',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein',
    passwordTooShort: 'Passwort muss mindestens 6 Zeichen lang sein',

    // User Tour
    userTour: {
      title: 'Benutzer-Tour',
      description: 'Aktivieren oder deaktivieren Sie geführte Touren in der gesamten Anwendung, um Ihnen bei der Navigation und beim Erlernen der Funktionen zu helfen.',
      enable: 'Tour aktivieren',
      disable: 'Tour deaktivieren',
    },
  },

  // Authentication Pages
  auth: {
    // Common
    emailAddress: 'E-Mail-Adresse',
    password: 'Passwort',
    confirmPassword: 'Passwort bestätigen',
    loading: 'Lädt...',
    processing: 'Verarbeitet...',
    back: 'Zurück',
    // Login page
    loginTitle: 'Willkommen zurück',
    loginSubtitle: 'Melden Sie sich in Ihrem Konto an',
    enterEmail: 'E-Mail eingeben',
    enterPassword: 'Passwort eingeben',
    rememberMe: 'Angemeldet bleiben',
    forgotPasswordLink: 'Passwort vergessen?',
    signIn: 'Anmelden',
    dontHaveAccount: 'Noch kein Konto?',
    registerLink: 'Registrieren',
    pleaseEnterValidDetails: 'Bitte geben Sie gültige Details ein',
    loggingIn: 'Anmelden...',

    // Register page
    registerTitle: 'Konto erstellen',
    registerSubtitle: 'Erstellen Sie Ihr Konto',
    fullName: 'Vollständiger Name',
    enterFullName: 'Vollständigen Namen eingeben',
    enterEmailAddress: 'E-Mail-Adresse eingeben',
    passwordHint: 'Passwort muss mindestens 6 Zeichen haben',
    agreeTerms: 'Ich stimme den Allgemeinen Geschäftsbedingungen zu',
    iAgreeToThe: 'Ich stimme den',
    termsAndConditions: 'Allgemeinen Geschäftsbedingungen zu',
    register: 'Registrieren',
    alreadyHaveAccount: 'Bereits ein Konto?',
    loginLink: 'Anmelden',
    pleaseAgreeToTheTermsAndConditions: 'Bitte stimmen Sie den Allgemeinen Geschäftsbedingungen zu',
    passwordMustBeAtLeast6Characters: 'Passwort muss mindestens 6 Zeichen lang sein',
    pleaseFillInAllInformation: 'Bitte füllen Sie alle Informationen aus',
    registrationSuccessful: 'Registrierung erfolgreich! Weiterleitung zum Dashboard...',
    registrationSuccessfulPleaseLogin: 'Registrierung und Arbeitsbereich-Setup erfolgreich abgeschlossen! Bitte melden Sie sich an, um fortzufahren.',
    pleaseWaitRedirecting: 'Bitte warten Sie, während wir Sie zur Anmeldeseite weiterleiten...',
    registrationError: 'Bei der Registrierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    registrationWithProviderFailed: 'Registrierung mit {provider} fehlgeschlagen',

    // Auth Callback page
    finalizingAuthentication: 'Authentifizierung wird abgeschlossen',
    settingUpWorkspace: 'Arbeitsbereich wird eingerichtet',
    authenticationComplete: 'Authentifizierung abgeschlossen',
    authenticationFailed: 'Authentifizierung fehlgeschlagen',
    pleaseWaitAuthenticating: 'Bitte warten Sie, während wir Ihr Konto authentifizieren...',
    pleaseWaitSettingUpWorkspace: 'Bitte warten Sie, während wir Ihren Arbeitsbereich einrichten...',
    redirectingToDashboard: 'Weiterleitung zum Dashboard...',
    workspaceCreatedSuccessfully: 'Arbeitsbereich erfolgreich erstellt!',
    welcomeBack: 'Willkommen zurück! Weiterleitung zu Ihrem Arbeitsbereich...',
    tryAgain: 'Erneut versuchen',
    thisEmailIsAlreadyRegistered: 'Diese E-Mail-Adresse ist bereits registriert',
    invalidEmail: 'Ungültige E-Mail-Adresse',
    emailNotConfirmed: 'E-Mail nicht bestätigt',
    invalidCredentials: 'Ungültige Anmeldedaten',
    tooManyRequestsPleaseTryAgainLater: 'Zu viele Anfragen, bitte versuchen Sie es später erneut',
    anErrorOccurredPleaseRetry: 'Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut',

    // Recover password page
    recoverPasswordTitle: 'Passwort zurücksetzen',
    recoverPasswordSubtitle: 'E-Mail eingeben, um Passwort zurückzusetzen',
    sendResetLink: 'Passwort zurücksetzen',
    sending: 'Senden...',
    backToLogin: 'Zurück zu',
    logIn: 'Anmelden',

    // Reset password page
    setNewPasswordTitle: 'Neues Passwort festlegen',
    newPassword: 'Neues Passwort',
    enterNewPassword: 'Neues Passwort eingeben',
    confirmNewPassword: 'Neues Passwort bestätigen',
    updatePassword: 'Passwort aktualisieren',
    updating: 'Aktualisieren...',
    goToLogin: 'Zur Anmeldung',

    // Social login
    continueWithGoogle: 'Google',
    orDivider: 'Oder',

    // Validation messages
    validEmailRequired: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    passwordMinLength: 'Passwort muss mindestens 6 Zeichen lang sein',
    passwordsDoNotMatch: 'Passwörter stimmen nicht überein',

    // Success/Error messages
    resetLinkSent: 'Ein Passwort-Reset-Link wurde an {email} gesendet. Bitte überprüfen Sie Ihre E-Mail und folgen Sie den Anweisungen zum Zurücksetzen Ihres Passworts.',
    passwordResetSuccess: 'Ihr Passwort wurde erfolgreich aktualisiert! Sie können sich jetzt mit Ihrem neuen Passwort anmelden.',
    resetLinkError: 'Fehler beim Senden der Reset-E-Mail',
    updatePasswordError: 'Fehler beim Aktualisieren des Passworts',
    unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    invalidResetLink: 'Ungültiger oder abgelaufener Reset-Link. Bitte fordern Sie ein neues Passwort-Reset an.',
    sessionCheckError: 'Reset-Link konnte nicht verifiziert werden. Bitte versuchen Sie es erneut.',
    registrationSuccessCheckEmail: 'Registrierung erfolgreich. Bitte überprüfen Sie Ihre E-Mail.',
    sessionExpired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    sessionError: 'Ein Fehler ist mit Ihrer Sitzung aufgetreten. Bitte melden Sie sich erneut an.',
  },
  comingSoon: {
    title: 'Bald verfügbar',
    description: 'Wir machen das System noch besser.',
  },
  welcome: {
    title: 'Willkommen bei Sellbase',
    subtitle: 'Was möchtest du heute machen?',
    newChatBot: 'Neue erstellen',
    createFirst: 'Erstelle deinen ersten ChatBot',
    noChatbots: 'Keine Chatbots verfügbar',
    limitReachedTooltip: 'Du kannst maximal 1 Chatbot erstellen.',
  },
  onboarding: {
    title: 'Neuer ChatBot',
    steps: {
      basicInfo: 'Grundinformationen',
      dataSources: 'Datenquellen',
      chatInterface: 'Chat-Interface',
    },
    step1: {
      description:
        'Diese Einrichtungsanleitung unterstützt Sie bei der ersten Konfiguration Ihres ChatBots. Sobald der Bot erstellt wurde, können Sie die Einstellungen später ändern und ergänzen.',
      internalNameLabel: 'Interner Chatbot-Name',
      internalNamePlaceholder: 'Mein erster ChatBot',
      displayNameLabel: 'Anzeigename deines Chatbots',
      displayNamePlaceholder: 'James Bot',
      descriptionLabel: 'Chatbot-Beschreibung',
      descriptionPlaceholder: 'Beschreibung',
      checking: 'Prüfe auf eingerichteten Chatbot...',
      limitReached: 'Sie haben das maximale Limit von 1 Chatbot pro Mandant erreicht.',
      manageExisting: 'Bitte verwalten Sie Ihren bestehenden Chatbot über das Dashboard.',
      limitReachedTitle: 'Chatbot-Limit erreicht',
      backToDashboard: 'Zurück zum Dashboard',
    },
    step2: {
      description:
        'Damit Ihr ChatBot weiß, worüber er sprechen soll. Ihr Online-Shop dient als Grundlage dafür, weshalb die URL oder eine Sitemap benötigt wird.',
      description2:
        'Wenn Sie die erste Konfiguration abgeschlossen haben, können Sie Ihren ChatBot mit zusätzlichen Informationen aus Dateien, Dokumenten und Ihren eigenen Texteingaben trainieren.',
      urlTitle: 'Ihre Online-Shop URL',
      urlPlaceholder: 'mein-shop.de',
      urlDescription: 'Dadurch werden alle Links gecrawlt, die mit der URL beginnen (ohne Dateien auf der Website).',
      fetchButton: 'Website abrufen',
      sitemapTitle: 'Sitemap einreichen',
      sitemapPlaceholder: 'mein-shop.de/sitemap.xml',
      urlDescriptionSitemap: 'Die Sitemap-XML wird von der URL abgerufen, geparst und für das Crawling genutzt.',
      loadButton: 'Sitemap laden',
      foundLinkTile: 'Gefundene Links',
      failLinkTile: 'Fehlgeschlagene Links',
      addUrlTitle: 'Neue URL hinzufügen',
      addUrl: 'URL hinzufügen',
      addListUrl: {
        title: 'Liste von URLs hinzufügen',
        placeholder: 'Geben Sie jede URL in einer neuen Zeile ein...',
        invalidUrls: 'Die folgenden URLs sind ungültig',
        processing: 'URL-Liste wird verarbeitet...',
        success: '{count} URLs als neue Quelle hinzugefügt.',
        noUrls: 'Keine gültigen URLs wurden hinzugefügt.',
        error: 'Fehler beim Hinzufügen von URLs: ',
      },
      fetchSuccess: 'Website-Quelle hinzugefügt',
      fetchError: 'Fehler beim Abrufen der Website: ',
      sitemapSuccess: 'Sitemap-Quelle hinzugefügt',
      sitemapError: 'Fehler beim Laden der Sitemap: ',
    },
    step3: {
      description:
        'Hier definieren Sie, wie Ihr ChatBot aussieht. Mit der Vorschau können Sie ihn auch direkt ausprobieren.',
      messages: 'Nachrichten',
      welcomeMessage: 'Willkommensnachricht',
      suggestedMessages: 'Vorgeschlagene Nachrichten',
      messagePlaceholder: 'Nachricht...',
      enterNewLine: 'Geben Sie jede Nachricht in einer neuen Zeile ein.',
      visualAppearance: 'Visuelles Erscheinungsbild',
      theme: 'Theme',
      themes: {
        light: 'Hell',
        dark: 'Dunkel',
      },
      avatarImage: 'Avatar-Bild',
      chatIcon: 'Chat-Symbol',
      uploadImage: 'Bild hochladen',
      remove: 'Entfernen',
      imageSupport: 'Unterstützt JPG, PNG und SVG Dateien bis zu 1MB',
      userMessageColor: 'Benutzer-Nachrichtenfarbe',
      chatButtonColor: 'Chat-Button-Farbe',
      headerColor: 'ChatBox-Kopfzeilenfarbe',
      reset: 'Zurücksetzen',
      chatAlignment: 'Chat-Ausrichtung',
      alignments: {
        left: 'Links',
        right: 'Rechts',
      },
      miscellaneous: 'Sonstiges',
      autoShowWelcome: 'Willkommensnachrichten-Popup automatisch anzeigen nach',
      seconds: 'Sekunden',
      negativeToDisable: '(negativ zum Deaktivieren)',
      preview: 'Vorschau',
      launchChatBot: 'ChatBot starten',
      defaultWelcomeMessage: 'Hallo! Wie kann ich Ihnen heute helfen?',
      defaultMessagePlaceholder: 'Schreiben Sie Ihre Nachricht...',
    },
    result: {
      title: 'Mein erster ChatBot Vorschau',
      description:
        'Hurra! Mein erster ChatBot ist startklar. Hier sind die nächsten Schritte, die Sie tun können.',
      webshopTitle: 'Platzieren Sie ihn in Ihrem Webshop',
      getCode: 'Code abrufen',
      dataSources: 'Datenquellen optimieren',
      uploadData: 'Zusätzliche Daten hochladen',
      visualTitle: 'Erscheinungsbild ändern',
      changeAppearance: 'Style es',
      preview: 'Vorschau',
      messagePlaceholder: 'Nachricht...',
    },
  },
  common: {
    back: 'Zurück',
    continue: 'Weiter',
    view: 'Ansehen',
    edit: 'Bearbeiten',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    deleteAll: 'Alle löschen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    saving: 'Wird gespeichert...',
    copy: 'Kopieren',
    show: 'Anzeigen',
    hide: 'Ausblenden',
    clickToEdit: 'Zum Bearbeiten klicken',
    chatAssistant: 'Chat-Assistent',
    totalLinks: 'Gefundene Links: {count}',
    copySuccess: 'In die Zwischenablage kopiert',
    error: 'Fehler: ',
    loading: 'Lädt...',
    filter: 'Filtern',
    refresh: 'Aktualisieren',
    search: 'Suchen',
    activeForBot: 'Für Bot aktiv',
    add: 'Hinzufügen',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    deleted: 'Erfolgreich gelöscht',
    deleteFailed: 'Löschen fehlgeschlagen',
    open: 'Öffnen',
    justNow: 'Gerade jetzt',
  },
  products: {
    title: 'Produktdaten',
    description:
      'Liste der Trainingsdaten, die als Produkte definiert wurden. Sie können die Informationen überprüfen und korrigieren oder in Inhalte umwandeln.',
    columns: {
      id: 'Artikel #',
      category: 'Kategorie',
      name: 'Produktname',
      lastUpdate: 'Letzte Aktualisierung',
      itemNo: 'Artikel #',
      status: 'Status',
      used: 'Verwendet',
    },
    loading: 'Lädt Produkte...',
    noProducts: 'Keine Produkte gefunden',
    noProductsFound: 'Keine Produkte gefunden',
    noProductsFoundDescription: 'Habe kein Produkt',
    noProductsFoundIcon: 'mgc_box_line',
    loadingProducts: 'Lädt Produkte...',
    loadError: 'Fehler beim Laden der Produkte',
    detail: {
      title: 'Produktdetails',
      editTitle: 'Produkt bearbeiten',
      itemNo: 'Artikel Nr.',
      category: 'Kategorie',
      price: 'Preis',
      name: 'Produktname',
      shortDescription: 'Kurzbeschreibung',
      longDescription: 'Ausführliche Beschreibung',
      sku: 'Artikelnummer',
      weight: 'Gewicht',
      dimensions: 'Abmessungen',
      material: 'Material',
      features: 'Eigenschaften',
      images: 'Bilder'
    },
    linkSources: 'Link-Quellen',
    foundUrlsTitle: 'Gefundene URLs',
    noFoundUrls: 'Noch keine URLs gefunden',
    lastCrawled: 'Zuletzt gecrawlt',
    linksCount: 'Links:',
    linksIncluded: 'LINKS ENTHALTEN',
    websiteCrawledNew: 'Website erfolgreich gecrawlt. {count} URLs gefunden.',
    sitemapLoadedNew: 'Sitemap erfolgreich geladen. {count} URLs gefunden.',
    loadMoreError: 'Fehler beim Laden weiterer URLs: ',
    noSourcesToTrain: 'Keine Quellen zum Trainieren',
    trainingUrls: '{count} Quellen werden trainiert...',
    trainingJobStarted: 'Trainingsjob für {count} Quellen gestartet. Daten werden in Kürze aktualisiert.',
    urlsTrainedSuccessfully: '{count} URLs erfolgreich trainiert',
    trainingFailed: 'Training fehlgeschlagen: ',
    addingUrlList: 'URL-Liste wird verarbeitet...',
    addedUrlListResult: '{count} URLs als neue Quelle hinzugefügt.',
    addedUrlListNone: 'Keine gültigen URLs wurden hinzugefügt',
    addUrlListError: 'Fehler beim Hinzufügen von URLs: ',
    batchAndTrain: 'Batch-Training',
    sourcesReady: 'Quelle(n) bereit zum Trainieren',
    sourcesInfo: 'Website-Quellen',
  },
  content: {
    title: 'Inhaltsdaten',
    description:
      'Liste der Trainingsdaten, die als Inhalte definiert wurden. Sie können die Informationen überprüfen und korrigieren oder in Produkte umwandeln.',
    columns: {
      id: 'Artikel #',
      category: 'Kategorie',
      name: 'Produktname',
      lastUpdate: 'Letzte Aktualisierung',
      status: 'Status',
    },
    loadSuccess: 'Inhalt erfolgreich geladen',
    loading: 'Lädt Inhalte...',
    noContents: 'Keine Inhalte gefunden',
    noContentsFound: 'Keine Inhalte gefunden',
    noContentsFoundDescription: 'Habe keinen Inhalt',
    noContentsFoundIcon: 'mgc_article_line',
    loadingContents: 'Lädt Inhalte...',
    detail: {
      title: 'Inhaltsdetails',
      editTitle: 'Inhalt bearbeiten',
      texts: 'Texte',
      images: 'Bilder',
      mainHeadline: 'Hauptüberschrift',
      contentText: 'Inhaltstext',
      pageType: 'Seitentyp',
      language: 'Sprache',
      contentUrl: 'Inhalts-URL',
      usedByChatbots: 'Verwendet von Chatbots',
      noImagesAvailable: 'Keine Bilder verfügbar',
      moreImages: '+{count} weitere Bilder'
    }
  },
  chat: {
    playground: {
      loading: 'Spielplatz wird geladen...'
    },
    preview: {
      title: 'Vorschau',
      description:
        'Der Spielplatz für Ihren ChatBot. Hier definieren Sie auch die grundlegenden Einstellungen und können einzelne Bots löschen.',
      internalNameLabel: 'Interner Name Ihres ChatBots',
      displayNameLabel: 'Anzeigename Ihres ChatBots',
      previewTitle: 'Vorschau',
      messagePlaceholder: 'Nachricht...',
      selectBot: 'Chatbot auswählen',
      loadingChatbots: 'Chatbots werden geladen...',
      chatbotsLoaded: 'Chatbots erfolgreich geladen',
      noChatbotsAvailable: 'Keine Chatbots verfügbar',
      loadingChatbot: 'Chatbot wird geladen...',
      chatbotLoaded: 'Chatbot erfolgreich geladen',
      error: 'Fehler: ',
      save: 'Änderungen speichern',
      saving: 'Änderungen werden gespeichert...',
      saveSuccess: 'Änderungen erfolgreich gespeichert',
      saveError: 'Fehler beim Speichern der Änderungen: ',
      noSelection: 'Kein Chatbot ausgewählt',
      revisions: 'Revisionen',
      deleteChatbot: 'Chatbot löschen',
      sampleUserMessage: 'Hallo, wie geht es dir?',
      refresh: 'Daten aktualisieren',
      defaultChatbotName: 'Chatbot',
      playgroundDescription: 'Der Spielplatz für Ihren ChatBot. Hier definieren Sie auch die grundlegenden Einstellungen und können einzelne Bots löschen.',
      chatbotNameLabel: 'Chatbot Name',
      namePlaceholder: 'Name',
      chatbotDescriptionLabel: 'Chatbot Beschreibung',
      descriptionPlaceholder: 'Dies ist mein erster ChatBot',
      saveChangesButton: 'Änderungen speichern',
      revisionsButton: 'Revisionen',
      deleteChatbotButton: 'Chatbot löschen',
      playgroundStarted: 'Spielplatz gestartet',

      // Additional keys for save/delete functionality
      invalidForm: 'Bitte füllen Sie die erforderlichen Felder aus',
      deleting: 'Chatbot wird gelöscht...',
      deleteSuccess: 'Chatbot erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen des Chatbots: ',
      confirmDelete: 'Sind Sie sicher, dass Sie diesen Chatbot löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    },
    interface: {
      title: 'Chat-Interface',
      description:
        'Hier können Sie Ihr Chat-Interface konfigurieren, Nachrichten ändern, Farben und weitere Einstellungen vornehmen',
      selectBot: 'Chatbot auswählen',
      noChatbotsAvailable: 'Keine Chatbots verfügbar',
      refresh: 'Aktualisieren',
      save: 'Speichern',
      loadingChatbots: 'Chatbots werden geladen...',
      loading: 'Wird geladen...',
      chatbotsLoaded: 'Chatbots erfolgreich geladen',
      messages: 'Nachrichten',
      welcomeMessage: 'Willkommensnachricht',
      suggestedMessages: 'Vorgeschlagene Nachrichten',
      messagePlaceholder: 'Nachricht-Platzhalter',
      enterNewLine: 'Geben Sie jede Nachricht in einer neuen Zeile ein.',
      visualAppearance: 'Visuelles Erscheinungsbild',
      theme: 'Theme',
      themes: {
        light: 'Hell',
        dark: 'Dunkel',
      },
      avatarImage: 'Avatar-Bild',
      chatIcon: 'Chat-Symbol',
      uploadImage: 'Bild hochladen',
      remove: 'Entfernen',
      imageSupport: 'Unterstützt JPG, PNG und SVG Dateien bis zu 1MB',
      userMessageColor: 'Benutzer-Nachrichtenfarbe',
      chatButtonColor: 'Chat-Button-Farbe',
      headerColor: 'ChatBox-Kopfzeilenfarbe',
      reset: 'Zurücksetzen',
      chatAlignment: 'Chat-Ausrichtung',
      alignments: {
        left: 'Links',
        right: 'Rechts',
      },
      miscellaneous: 'Sonstiges',
      autoShowWelcome: 'Willkommensnachrichten-Popup automatisch anzeigen nach',
      seconds: 'Sekunden',
      negativeToDisable: '(negativ zum Deaktivieren)',
      preview: 'Vorschau',
    },
    connections: {
      title: 'Website-Verbindung',
      description: 'Konfigurieren Sie Ihre Website-Verbindung und betten Sie den Chatbot ein',
      connectionSettings: 'Verbindungseinstellungen',
      storeUrl: 'Shop-URL',
      storeUrlPlaceholder: 'https://example-shop.com',
      accessToken: 'Zugriffstoken',
      authentication: 'Authentifizierung',
      embedCode: 'Einbettungscode',
      noChange: 'Keine Änderung',
      embedDescription: 'Fügen Sie den folgenden Code in den Header Ihrer Website ein, um den Chatbot zu aktivieren',
      embedInstructions: {
        title: 'So betten Sie ein:',
        step1: 'Kopieren Sie den obigen Code',
        step2: 'Fügen Sie ihn in den <head>-Bereich Ihrer Website ein',
        step3: 'Der Chatbot wird automatisch auf Ihrer Website angezeigt'
      },
      copy: 'Kopieren',
      saveSuccess: 'Verbindungseinstellungen erfolgreich gespeichert',
      saveError: 'Fehler beim Speichern der Verbindungseinstellungen',
      embedCopySuccess: 'Einbettungscode in die Zwischenablage kopiert',
      urlRequired: 'Shop-URL ist erforderlich'
    },
    logs: {
      title: 'Chat-Protokolle',
      description: 'Sehen und analysieren Sie Chatgespräche zwischen Benutzern und Ihrem Chatbot.',
      searchPlaceholder: 'Chat-Protokolle durchsuchen',
      filter: 'Filtern',
      export: 'Exportieren',
      noLogs: 'Keine Chat-Protokolle gefunden.',
      viewConversation: 'Gespräch ansehen',
      back: 'Zurück zu Protokollen',
      date: 'Datum',
      time: 'Zeit',
      noChatbotsAvailable: 'Keine Chatbots verfügbar',
      selectChatbot: 'Chatbot auswählen',
      loading: 'Protokolle werden geladen...',
      loadError: 'Fehler beim Laden der Protokolle',
    },
  },
  dataSources: {
    common: {
      selectBot: 'Wähle einen Bot',
      chatBotName: 'Chat Bot {number}',
      of: 'von',
      urls: 'URLs',
      chatbotsLoaded: 'Chatbots erfolgreich geladen',
      noChatbotsAvailable: 'Keine Chatbots verfügbar',
      noChatbotSelected: 'Kein Chatbot ausgewählt',
      loadingChatbots: 'Chatbots werden geladen...',
      error: 'Fehler: ',
      loadingUrls: 'Trainierte URLs werden geladen...',
      urlsLoaded: 'Trainierte URLs erfolgreich geladen',
      fetchError: 'Fehler beim Laden der trainierten URLs: ',
      urlRequired: 'URL ist erforderlich',
      selected: 'ausgewählt',
      selectAll: 'Alle auswählen',
      deselectAll: 'Alle abwählen',
    },
    website: {
      title: 'Website',
      description: 'Sie können entweder Ihre URL oder eine Sitemap verwenden',
      loadingChatbots: 'Chatbots werden geladen...',
      chatbotsLoaded: 'Chatbots erfolgreich geladen',
      noChatbotsAvailable: 'Keine Chatbots verfügbar',
      error: 'Fehler: ',
      loadingUrls: 'Trainierte URLs werden geladen...',
      urlsLoaded: 'Trainierte URLs erfolgreich geladen',
      fetchError: 'Fehler beim Laden der trainierten URLs: ',
      urlRequired: 'URL ist erforderlich',
      fetchingWebsite: 'Website wird abgerufen...',
      websiteFetched: 'Website erfolgreich abgerufen! {0} neue URLs gefunden.',
      sitemapRequired: 'Sitemap-URL ist erforderlich',
      loadingSitemap: 'Sitemap wird geladen...',
      sitemapLoaded: 'Sitemap erfolgreich geladen! {0} URLs gefunden.',
      loadError: 'Fehler beim Laden der Sitemap: ',
      noMoreUrls: 'Funktionalität zum Laden weiterer URLs nicht verfügbar.',
      noUrlsToDelete: 'Keine URLs zum Löschen vorhanden.',
      deletingAll: 'Alle URLs werden gelöscht...',
      allDeleted: 'Alle URLs erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen der URLs: ',
      deletingUrl: 'URL wird gelöscht...',
      urlDeleted: 'URL erfolgreich gelöscht',
      selectBot: 'Chatbot auswählen',
      refresh: 'Aktualisieren',
      confirmDeleteAllTitle: 'Alle URLs löschen bestätigen',
      confirmDeleteAllMessage: 'Sind Sie sicher, dass Sie alle trainierten URLs löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      confirmDeleteUrlTitle: 'URL löschen bestätigen',
      confirmDeleteUrlMessage: 'Sind Sie sicher, dass Sie diese URL löschen möchten? ',
      urlDescription: 'Dies wird alle Links crawlen, die mit der URL beginnen (ohne Dateien auf der Website).',
      urlPlaceholder: 'mein-shop.de',
      fetchButton: 'Website abrufen',
      sitemapTitle: 'Sitemap einreichen',
      sitemapPlaceholder: 'mein-shop.de/sitemap.xml',
      loadButton: 'Sitemap laden',
      trainedUrlsTitle: 'Trainierte URLs',
      noTrainedUrls: 'Noch keine trainierten URLs',
      loadingMoreUrls: 'Weitere URLs werden geladen...',
      noMoreUrlsToLoad: 'Keine weiteren URLs zum Laden vorhanden',
      urlTitle: 'Crawlen',
      allUrlsLoaded: 'Alle URLs geladen',
      loadMore: 'Mehr laden',
      urlDescriptionSitemap: 'Die Sitemap-XML wird von der URL abgerufen, geparst und für das Crawling genutzt.',
      linkSources: 'Link-Quellen',
      foundUrlsTitle: 'Gefundene URLs',
      noFoundUrls: 'Noch keine URLs gefunden',
      lastCrawled: 'Zuletzt gecrawlt',
      linksCount: 'Links:',
      linksIncluded: 'LINKS ENTHALTEN',
      websiteCrawledNew: 'Website erfolgreich gecrawlt. {count} URLs gefunden.',
      sitemapLoadedNew: 'Sitemap erfolgreich geladen. {count} URLs gefunden.',
      loadMoreError: 'Fehler beim Laden weiterer URLs: ',
      noSourcesToTrain: 'Keine Quellen zum Trainieren',
      trainingUrls: '{count} Quellen werden trainiert...',
      trainingJobStarted: 'Trainingsjob für {count} Quellen gestartet. Daten werden in Kürze aktualisiert.',
      urlsTrainedSuccessfully: '{count} URLs erfolgreich trainiert',
      trainingFailed: 'Training fehlgeschlagen: ',
      addingUrlList: 'URL-Liste wird verarbeitet...',
      addedUrlListResult: '{count} URLs als neue Quelle hinzugefügt.',
      addedUrlListNone: 'Keine gültigen URLs wurden hinzugefügt',
      addUrlListError: 'Fehler beim Hinzufügen von URLs: ',
      batchAndTrain: 'Batch-Training',
      sourcesReady: 'Quelle(n) bereit zum Trainieren',
      sourcesInfo: 'Website-Quellen',
      sourcesSelected: 'Quelle(n) ausgewählt',
    },
    files: {
      title: 'Dateien',
      description: 'Sie können Dokumente als Trainingsmaterial für Ihren Bot hochladen.',
      dropAreaText: 'Dateien hier ablegen oder zum Hochladen klicken.',
      supportedFileTypes: 'Unterstützte Dateitypen: .pdf, .doc, .docx, .txt',
      uploadedFilesTitle: 'Hochgeladene Dateien',
      localFilesTitle: 'Ausgewählte Dateien',
      trainedFilesTitle: 'Trainierte Dateien',
      trainButton: 'Neue Dateien trainieren',
      training: 'Trainiert...',
      trainSuccess: 'Dateien erfolgreich trainiert',
      trainError: 'Fehler beim Trainieren der Dateien: ',
      loadError: 'Fehler beim Laden der Dateien: ',
      deleteSuccess: 'Datei erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen der Datei: ',
      deleteAllError: 'Fehler beim Löschen aller Dateien: ',
      localFilesCleared: 'Lokale Dateien gelöscht',
      allTrainedDeleted: 'Alle trainierten Dateien gelöscht',
      noFilesToTrain: 'Keine Dateien zum Trainieren',
      trainingFiles: 'Dateien werden trainiert...',
      confirmDeleteLocalTitle: 'Lokale Dateien löschen',
      confirmDeleteLocalMessage: 'Sind Sie sicher, dass Sie alle ausgewählten Dateien aus der Liste entfernen möchten? Sie wurden noch nicht hochgeladen.',
      confirmDeleteTrainedTitle: 'Trainierte Dateien löschen',
      confirmDeleteTrainedMessage: 'Sind Sie sicher, dass Sie alle trainierten Dateien löschen möchten? Dies entfernt sie aus den Trainingsdaten Ihres Chatbots.',
      removePendingSuccess: 'Dateien erfolgreich entfernt',
      loadingFiles: 'Dateien werden geladen...',
      loadMore: 'Mehr laden',
      allFilesLoaded: 'Alle Dateien geladen',
    },
    text: {
      title: 'Textdatenquelle',
      description: 'Fügen Sie einfach einige Zeilen hinzu, die Ihr Chatbot verwenden soll.',
      placeholder: 'Text eingeben...',
      titlePlaceholder: 'Titel eingeben...',
      trainButton: 'Neuen Text trainieren',
      trainedTextsTitle: 'Trainierte Texte',
      noTextsTrainedYet: 'Noch keine Texte trainiert.',
      editingMode: 'Text bearbeiten',
      training: 'Trainieren...',
      updating: 'Aktualisieren...',
      updateButton: 'Text aktualisieren',
      emptyText: 'Bitte Titel und Inhalt eingeben.',
      trainingText: 'Text wird trainiert...',
      trainSuccess: 'Text erfolgreich trainiert!',
      trainError: 'Fehler beim Trainieren des Textes: ',
      updatingText: 'Text wird aktualisiert...',
      updateSuccess: 'Text erfolgreich aktualisiert!',
      updateError: 'Fehler beim Aktualisieren des Textes: ',
      deletingText: 'Text wird gelöscht...',
      deleteSuccess: 'Text erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen des Textes: ',
      noTextsToDelete: 'Keine Texte zum Löschen.',
      deletingAllTexts: 'Alle Texte werden gelöscht...',
      deleteAllSuccess: 'Alle Texte erfolgreich gelöscht',
      deleteAllError: 'Fehler beim Löschen aller Texte: ',
      editing: 'Wird bearbeitet...', // For the list item status
      allTextsTitle: 'Alle Texte',
      content: 'Inhalt',
      loadingTexts: 'Texte werden geladen...',
      loadMore: 'Mehr laden',
      trained: 'Trainiert',
      allTextsLoaded: 'Alle Texte geladen',
    },
    faq: {
      title: 'Q&A Datenquelle',
      description: 'Fügen Sie häufig gestellte Fragen und deren Antworten hinzu.',
      placeholder: 'Text eingeben...',
      questionLabel: 'Frage',
      answerLabel: 'Antwort',
      trainButton: 'FAQ trainieren',
      emptyFields: 'Bitte Frage und Antwort eingeben.',
      training: 'FAQ wird trainiert...',
      trainSuccess: 'FAQ erfolgreich trainiert!',
      trainError: 'Fehler beim Trainieren der FAQ: ',
      trainedQasTitle: 'Trainierte Q&As',
      noQasTrainedYet: 'Noch keine Q&As trainiert.',
      editing: 'Wird bearbeitet...',
      updatingQa: 'Q&A wird aktualisiert...',
      updateSuccess: 'Q&A erfolgreich aktualisiert!',
      updateError: 'Fehler beim Aktualisieren der Q&A: ',
      updateButton: 'Q&A aktualisieren',
      updating: 'Q&A wird aktualisiert...',
      editingMode: 'Q&A bearbeiten',
      deleteSuccess: 'Q&A erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen der Q&A: ',
      noQasToDelete: 'Keine Q&As zum Löschen.',
      deletingQa: 'Q&A wird gelöscht...',
      deletingAllQas: 'Alle Q&As werden gelöscht...',
      deleteAllSuccess: 'Alle Q&As erfolgreich gelöscht',
      deleteAllError: 'Fehler beim Löschen aller Q&As: ',
      addNewFaq: 'Neue FAQ hinzufügen',
      fillExistingFaqsFirst: 'Füllen Sie zuerst die bestehenden FAQs aus',
      allQasLoaded: 'Alle F&As geladen',
    },
    external: {
      title: 'Externes Wissen',
      description: 'Hier können Sie externe Quellen und Schlüsselwörter definieren, die dem Chat-Bot dabei helfen, Informationen zu den spezifischen Themen Ihres Shops bereitzustellen. Nützliche Optionen sind Wikipedia-Einträge oder informative Blogs.',
      urlLabel: 'Externe URL',
      urlPlaceholder: 'https://external-source.de',
      urlDescription: 'Dies wird alle Links crawlen, die mit der URL beginnen (ohne Dateien auf der Website).',
      keywordsLabel: 'Schlüsselwörter',
      keywordsPlaceholder: 'Schlüsselwort eingeben ...',
      keywordsDescription: 'Trennen Sie einzelne Schlüsselwörter mit Komma',
      fetchButton: 'Website abrufen',
      fetching: 'Website wird abgerufen...',
      fetchSuccess: 'Website erfolgreich abgerufen',
      fetchError: 'Fehler beim Abrufen der Website: ',
      confirmDeleteMessage: 'Sind Sie sicher, dass Sie diese externe Quelle löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      emptyDescription: 'Fügen Sie Ihre erste externe Quelle hinzu, um zu beginnen.',
      createSuccess: 'Externe Quellen erfolgreich erstellt',
      createError: 'Fehler beim Erstellen der externen Quellen: ',
      updateSuccess: 'Externe Quelle erfolgreich aktualisiert',
      updateError: 'Fehler beim Aktualisieren der externen Quelle: ',
      deleteSuccess: 'Externe Quelle erfolgreich gelöscht',
      deleteError: 'Fehler beim Löschen der externen Quelle: ',
      listTitle: 'Externe Quellen',
    },
  },
  inbox: {
    loading: 'Wird geladen...',
    error: 'Ein Fehler ist aufgetreten',
    noData: 'Keine Daten verfügbar',
    confirmDelete: 'Sind Sie sicher, dass Sie dieses Element löschen möchten?',
    deleteSuccess: 'Element erfolgreich gelöscht',
    deleteError: 'Fehler beim Löschen des Elements',
    tickets: {
      title: 'Tickets',
      description: 'Verwalten Sie Support-Tickets von Ihren Kunden',
      noTickets: 'Keine Tickets verfügbar',
      notCreated: 'Es wurden noch keine Tickets erstellt.',
      confirmDelete: 'Sind Sie sicher, dass Sie dieses Ticket löschen möchten?',
      columns: {
        id: 'ID',
        requestedBy: 'Angefordert von',
        subject: 'Betreff',
        description: 'Beschreibung',
        email: 'E-Mail',
        status: 'Status',
        createdDate: 'Erstellungsdatum',
        action: 'Aktion',
      },
      status: {
        new: 'Neu',
        send: 'Gesendet',
      },
      priority: {
        low: 'Niedrig',
        medium: 'Mittel',
        high: 'Hoch',
      },
    },
    leads: {
      title: 'Führt',
      description: 'Verwalten Sie Leads von Ihren Kunden',
      noLeads: 'Keine Leads verfügbar',
      notCreated: 'Es wurden noch keine Leads erstellt.',
      confirmDelete: 'Sind Sie sicher, dass Sie diesen Lead löschen möchten?',
      searchPlaceholder: 'Leads suchen',
      connect: 'Verbinden',
      export: 'Exportieren',
      columns: {
        email: 'E-Mail-Adresse',
        name: 'Name',
        signupDate: 'Anmeldedatum',
        action: 'Aktion',
        topics: 'Themen'
      }
    },
    emailSetting: {
      title: 'E-Mail-Einstellung',
      description: 'E-Mail-Einstellung zum Senden von E-Mails an Sie, wenn Kunden Feedback vom Chatbot senden',
      chatbotSelection: {
        title: '',
        description: 'Wählen Sie einen Chatbot aus, um E-Mail-Einstellungen für den Empfang von Kundenfeedback zu konfigurieren',
        placeholder: 'Chatbot auswählen',
        empty: 'Keine Chatbots verfügbar'
      },
      form: {
        title: 'E-Mail-Konfiguration',
        description: 'Konfigurieren Sie die E-Mail-Adresse, an die Sie Kundenfeedback-Benachrichtigungen erhalten möchten',
        emailLabel: 'E-Mail eingeben',
        emailPlaceholder: 'Geben Sie Ihre E-Mail ein',
        emailHint: 'E-Mail-Adresse, an die Kundenfeedback-Benachrichtigungen gesendet werden',
        saveButton: 'Speichern'
      },
      success: {
        title: 'Erfolg',
        saved: 'E-Mail-Einstellung erfolgreich gespeichert'
      },
      error: {
        title: 'Fehler',
        loadFailed: 'E-Mail-Einstellung konnte nicht geladen werden',
        saveFailed: 'E-Mail-Einstellung konnte nicht gespeichert werden',
        noChatbotSelected: 'Bitte wählen Sie zuerst einen Chatbot aus',
        emailRequired: 'E-Mail-Adresse ist erforderlich',
        emailInvalid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
      },
      alert: {
        notImplemented: 'Diese Funktion befindet sich in der Entwicklung.\\n\\nSie sind dabei, die E-Mail-Einstellung zu speichern für:\\nChatbot: {chatbot}\\nE-Mail: {email}\\n\\nMöchten Sie mit der Demo fortfahren?',
        saveSuccess: 'Demo erfolgreich abgeschlossen!\\n\\nE-Mail-Einstellung gespeichert für:\\nChatbot: {chatbot}\\nE-Mail: {email}\\n\\nHinweis: Dies ist eine Demoversion. In der Vollversion wird dies in der Datenbank gespeichert.',
        saveError: 'Demo-Speichern fehlgeschlagen!\\n\\nBitte versuchen Sie es erneut oder wenden Sie sich an den Support, wenn das Problem weiterhin besteht.'
      },
      info: {
        notImplemented: 'Diese Funktion befindet sich derzeit in der Entwicklung und ist nicht voll funktionsfähig. Dies ist eine Demo des Speicherprozesses.'
      },
      noChatbot: {
        title: 'Kein Chatbot ausgewählt',
        description: 'Bitte wählen Sie einen Chatbot aus, um E-Mail-Einstellungen zu konfigurieren'
      }
    },
    common: {
      loading: {
        leads: 'Leads werden geladen...',
        tickets: 'Tickets werden geladen...',
        emailSetting: 'E-Mail-Einstellung wird geladen...',
        chatbots: 'Chatbots werden geladen...'
      },
      actions: {
        delete: 'Löschen',
        selectItem: '{item} auswählen',
        resend: 'Erneut senden'
      }
    },
  },
  analytics: {
    chats: 'Chats',
    topics: 'Themen',
    chatAnalytics: 'Chat-Analytik',
    contents: 'Inhalt',
    topPages: 'Top-Seiten',
    dailyNumberOfChats: 'Tägliche Anzahl von Chats',
    showAllTopics: 'Alle Themen anzeigen',
    hideAllTopics: 'Alle Themen ausblenden',
    overview: 'Überblick',
    totalChats: 'Chats gesamt',
    completionRate: 'Abschlussrate',
    avgDuration: 'Durchschn. Dauer',
    satisfaction: 'Zufriedenheit',
    chatTrends: 'Chat-Trends',
    recentChats: 'Aktuelle Chats',
    id: 'ID',
    user: 'Benutzer',
    date: 'Datum',
    duration: 'Dauer',
    status: 'Status',
    completed: 'Abgeschlossen',
    abandoned: 'Abgebrochen',
    mostPopular: 'Beliebteste Themen',
    products: 'Produkte',
    shipping: 'Versand',
    returns: 'Rücksendungen',
    payment: 'Zahlung',
    account: 'Konto',
    other: 'Sonstiges',
    topicTrends: 'Themen-Trends',
    chartPlaceholder: 'Diagrammvisualisierung wird hier angezeigt',
    frequentQuestions: 'Häufigste Fragen',
    productAvailability: 'Frage zur Produktverfügbarkeit',
    shippingTime: 'Frage zur Lieferzeit',
    discountCodes: 'Frage zu Rabattcodes',
    returnPolicy: 'Frage zur Rückgaberichtlinie',
    paymentMethods: 'Frage zu Zahlungsmethoden',
    questionFrequency: '{count} mal in diesem Monat gefragt',
    filterByDate: 'Nach Datum filtern',
    dateRange: 'Datumsbereich',
    selectDateRange: 'Datumsbereich auswählen',
    allTime: 'Alle Zeit',
    lastMonth: 'Letzter Monat',
    lastYear: 'Letztes Jahr',
    totalMessages: 'Gesamt Nachrichten',
    productRecommendations: 'Produktempfehlungen',
    totalTopics: 'Gesamt Themen',
    popularTopics: 'Beliebte Themen',
    topicDistribution: 'Themenverteilung',
    fromLastMonth: 'vom letzten Monat',
    noDataAvailable: 'Keine Daten verfügbar',
    chartWillBeDisplayed: 'Diagrammvisualisierung wird hier angezeigt',
    topDomains: 'Top-Domains'
  },
  demo: {
    title: 'Sprachenwechsel-Demo',
    currentLanguage: 'Aktuelle Sprache',
    footer: 'Das System unterstützt jetzt vollständig mehrsprachig für Englisch (EN) und Deutsch (DE)',
    sections: {
      sidebar: 'Seitenleisten-Navigation',
      inbox: 'Posteingang-Modul',
      data: 'Daten-Modul',
      actions: 'Häufige Aktionen',
      account: 'Konto-Einstellungen',
      analytics: 'Analytik'
    }
  },
  tenant: {
    // TenantInitializationModal
    progressSteps: 'Fortschrittsschritte:',
    retry: 'Wiederholen',
    retrying: 'Wird wiederholt...',
    continue: 'Zur Anmeldung fortfahren',

    // Status titles
    preparingInitialization: 'Initialisierung wird vorbereitet...',
    initializingTenant: 'Mandant wird initialisiert',
    initializationSuccessful: 'Initialisierung erfolgreich!',
    initializationFailed: 'Initialisierung fehlgeschlagen',
    processing: 'Wird verarbeitet...',

    // Status descriptions
    preparingDescription: 'Das System bereitet die Initialisierung Ihres Mandanten vor...',
    runningDescription: 'Bitte warten Sie, während wir Ihr Konto und Ihre Daten einrichten.',
    completedDescription: 'Ihr Arbeitsbereich wurde erfolgreich initialisiert! Klicken Sie auf Fortfahren, um sich anzumelden und den Dienst zu nutzen.',
    failedDescription: 'Während der Initialisierung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.',
    processingDescription: 'Ihre Anfrage wird bearbeitet...',

    // Progress steps
    modelReload: 'Modell neu laden',
    creatingTypes: 'Typen erstellen',
    creatingRootItems: 'Stammelemente erstellen',
    creatingRelations: 'Beziehungen erstellen',
    creatingAttributes: 'Attribute erstellen',
    createNewAccount: 'Neues Konto erstellen',
    initializingWorkspace: 'Arbeitsbereich wird initialisiert...',
    setupFailed: 'Setup fehlgeschlagen',
    incompleteSetupDetected: 'Unvollständige Setup-Erkennung',

    // Messages
    initializingTenantMessage: 'Mandant wird initialisiert...',
    initializationProgress: '{step}... ({completed}/{total} abgeschlossen)',
    initializationTimeout: 'Zeitüberschreitung bei der Initialisierung. Abmelden...',
    statusCheckError: 'Initialisierungsstatus kann nicht überprüft werden. Abmelden...',
    statusPollingError: 'Fehler beim Überprüfen des Initialisierungsstatus. Abmelden...',
    reinitializingWorkspace: 'Arbeitsbereich wird neu initialisiert...',
    reRegistrationFailed: 'Arbeitsbereich-Setup konnte nicht neu gestartet werden. Bitte kontaktieren Sie den Support.',
    retryCriticalError: 'Beim Wiederholen ist ein kritischer Fehler aufgetreten.',
    setupWorkspaceError: 'Wir konnten Ihren Arbeitsbereich nicht automatisch einrichten. Bitte versuchen Sie es erneut.',
    creatingWorkspace: 'Arbeitsbereich wird erstellt...',
    workspaceSetupComplete: 'Arbeitsbereich-Setup erfolgreich abgeschlossen!',
    accountCleanedUpDueToFailure: 'Konto aufgrund von Setup-Fehlern bereinigt'
  },
  messageSection: {
    title: 'Nachrichten',
    chatboxTitle: 'Chatbox-Titel',
    welcomeMessage: 'Willkommensnachricht',
    welcomeMessageHint: 'Geben Sie eine Willkommensnachricht für Ihren Chatbot ein.',
    suggestedMessages: 'Vorgeschlagene Nachrichten',
    suggestedMessagesHint: 'Geben Sie vorgeschlagene Nachrichten ein, eine pro Zeile.',
    messagePlaceholder: 'Nachrichten-Platzhalter',
    welcomeCardStyle: 'Willkommenskarten-Stil',

  },

  welcomeMessageSection: {
    title: 'Willkommensnachricht',
    welcomeMessage: 'Willkommensnachricht',
    welcomeMessageHint: 'Geben Sie eine Willkommensnachricht für Ihren Chatbot ein. Sie können HTML zur Formatierung verwenden.',
    welcomeMessageStyle: 'Willkommensnachricht-Stil',
    welcomeMessageStyle1: 'Stil 1 – Einfache Nachricht',
    welcomeMessageStyle2: 'Stil 2 – Moderne Nachricht',
    welcomeMessageBackground: 'Willkommensnachricht-Hintergrund',
    autoShowWelcome: 'Willkommensnachrichten-Popups automatisch anzeigen nach',
    seconds: 'Sekunden',
    negativeToDisable: '(Negativ zum Deaktivieren)',
  },

  suggestedMessage: {
    placeholder: 'Vorgeschlagene Nachricht eingeben',
    remove: 'Diese Nachricht entfernen',
    empty: 'Noch keine vorgeschlagenen Nachrichten. Fügen Sie welche hinzu, um Benutzern den Gesprächseinstieg zu erleichtern.',
    add: 'Vorgeschlagene Nachricht hinzufügen'
  },
  conversationalStyle: {
    title: 'Gesprächsstil',
    style: 'Stil',
    friendly: 'Freundlich',
    professional: 'Professionell',
    casual: 'Lässig',
    creative: 'Kreativ',
    learnFromUrl: 'Von URL lernen',
    useEmojis: 'Emojis verwenden'
  },
  visualAppearance: {
    title: 'Visuelles Erscheinungsbild',
    theme: 'Theme',
    light: 'Hell',
    dark: 'Dunkel',
    avatarImage: 'Avatar-Bild',
    chatIcon: 'Chat-Symbol',
    botMessageColor: 'Bot-Nachrichtenfarbe',
    userMessageColor: 'Benutzer-Nachrichtenfarbe',
    chatboxHeaderColor: 'Chatbox-Header-Farbe',
    chatButtonColor: 'Chat-Button-Farbe',
    chatAlignment: 'Chat-Ausrichtung',
    bubbleAlignment: 'Chatbox-Bubble-Ausrichtung',
    left: 'Links',
    right: 'Rechts'
  },
  avatarManage: {
    support: 'Unterstützt JPG-, PNG- und SVG-Dateien bis zu 1 MB',
    upload: 'Bild hochladen',
    pasteUrl: 'URL einfügen',
    remove: 'Entfernen'
  },
  choiceColor: {
    reset: 'Zurücksetzen',
    hexValue: 'Hex-Wert',
    apply: 'Anwenden'
  },
  miscellaneous: {
    title: 'Sonstiges',
    autoShowWelcome: 'Willkommensnachrichten-Popups automatisch anzeigen nach',
    seconds: 'Sekunden',
    negativeToDisable: '(negativ zum Deaktivieren)'
  },

  backgroundImage: {
    support: 'Unterstützt JPG-, PNG- und SVG-Dateien bis zu 2 MB. Das Bild wird im ursprünglichen Seitenverhältnis angezeigt.',
    apply: 'Anwenden',
    cancel: 'Abbrechen',
    clickToUpload: 'Klicken Sie, um ein Bild hochzuladen',
    orDragImageHere: 'oder ziehen Sie ein Bild hierher',
    upload: 'Bild hochladen',
    pasteUrl: 'URL einfügen',
  },

  tour: {
    back: 'Zurück',
    skip: 'Überspringen',
    next: 'Weiter',
    finish: 'Fertig',
    steps: {
      chatbotList: {
        content: 'Dieser Bereich zeigt alle Ihre Chatbots. Sie können sie hier verwalten und bearbeiten.',
      },
      dataStats: {
        content: 'Zeigen Sie Ihre Datenstatistiken einschließlich Produkte, Inhalte und Trainingsfortschritt an.',
      },
      createChatbot: {
        content: 'Klicken Sie hier, um einen neuen Chatbot zu erstellen und den Setup-Assistenten zu starten.',
        timelineStep1: 'Schritt 1: Geben Sie grundlegende Informationen für Ihren Chatbot an, wie Name und Beschreibung.',
        timelineStep2: 'Schritt 2: Fügen Sie Datenquellen hinzu, wie Ihre Website-URL oder Sitemap, um Ihren Chatbot zu trainieren.',
        timelineStep3: 'Schritt 3: Passen Sie das Aussehen und Verhalten Ihrer Chat-Oberfläche an Ihre Marke an.',
        infoCard: 'Geben Sie hier einen Namen und eine Beschreibung für Ihren Chatbot ein. Das hilft Ihnen dabei, ihn später zu identifizieren.',
      },
    },
  }
}
